// Token validation utility
export const validateToken = (token) => {
  if (!token) return false;
  
  try {
    // Simple JWT token validation (checking structure and expiration)
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    
    const payload = JSON.parse(atob(parts[1]));
    const currentTime = Date.now() / 1000;
    
    // Check if token is expired
    if (payload.exp && payload.exp < currentTime) {
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

export const isTokenExpired = (token) => {
  return !validateToken(token);
};
